export default "<div>End with newline</div>"